<style scoped>
.vs-table--tbody-table .tr-values td {
    padding: 3px;
}
</style>

<template>
    <div>
        <div class="w-full vx-col mb-base">
            <vs-card title="Client Rate" class="p-4 mb-6">
                <div
                    slot="header"
                    class="flex flex-wrap items-center justify-between"
                >
                    <div class="flex items-center">
                        <vs-button
                            radius
                            color="primary"
                            icon="keyboard_backspace"
                            @click="$router.go(-1)"
                        ></vs-button>
                        <h4 class="ml-3">Add Client Rate</h4>
                    </div>
                    <vs-button
                        color="primary"
                        class="mb-4 mr-1 btn md:mb-0"
                        @click="save"
                        >Save</vs-button
                    >
                </div>
                <div class="mt-6 vx-row">
                    <div class="w-full vx-col lg:w-1/4">
                        <div class="mb-3 vx-row">
                            <div class="w-1/3 vx-col">Client ID*</div>
                            <div class="w-2/3 vx-col">
                                <vs-select
                                    class="selectExample"
                                    v-model="client_id"
                                    width="100%"
                                    autocomplete
                                    @input-change="
                                        searchDropdown($event, client)
                                    "
                                    @input="getRate"
                                >
                                    <vs-select-item
                                        v-for="(item, index) in client.data"
                                        :key="index"
                                        :value="item.id"
                                        :text="item.client_code"
                                    />
                                </vs-select>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-tabs class="mt-10">
                    <vs-tab label="Storage">
                        <div class="mb-3 vx-row">
                            <div class="w-full vx-col">
                                <label for class="vs-input--label"
                                    >Calculation Type</label
                                >
                                <v-select
                                    :options="calculation_types"
                                    v-model="formTypes.storage"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>
                        <vs-table
                            :data="storageItems"
                            hoverFlat
                            class="mt-base"
                        >
                            <template slot="thead">
                                <vs-th style="min-width: 200px">Min Qty</vs-th>
                                <vs-th style="min-width: 200px">Max Qty</vs-th>
                                <vs-th style="min-width: 200px">Cost</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                                <vs-tr
                                    :data="tr"
                                    :key="indextr"
                                    v-for="(tr, indextr) in data"
                                >
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.min_qty"
                                        />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.max_qty"
                                        />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.cost"
                                        />
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                    <vs-tab label="Inbound">
                        <div class="mb-3 vx-row">
                            <div class="w-full vx-col">
                                <label for class="vs-input--label"
                                    >Calculation Type</label
                                >
                                <v-select
                                    :options="calculation_types"
                                    v-model="formTypes.inbound"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>
                        <vs-table
                            :data="inboundItems"
                            hoverFlat
                            class="mt-base"
                        >
                            <template slot="thead">
                                <vs-th style="min-width: 200px">Min Qty</vs-th>
                                <vs-th style="min-width: 200px">Max Qty</vs-th>
                                <vs-th style="min-width: 200px">Cost</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                                <vs-tr
                                    :data="tr"
                                    :key="indextr"
                                    v-for="(tr, indextr) in data"
                                >
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.min_qty"
                                        />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.max_qty"
                                        />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.cost"
                                        />
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table> </vs-tab
                    ><vs-tab label="Outbound">
                        <div class="mb-3 vx-row">
                            <div class="w-full vx-col">
                                <label for class="vs-input--label"
                                    >Calculation Type</label
                                >
                                <v-select
                                    :options="calculation_types"
                                    v-model="formTypes.outbound"
                                    :clearable="false"
                                ></v-select>
                            </div>
                        </div>
                        <vs-table
                            :data="outboundItems"
                            hoverFlat
                            class="mt-base"
                        >
                            <template slot="thead">
                                <vs-th style="min-width: 200px">Min Qty</vs-th>
                                <vs-th style="min-width: 200px">Max Qty</vs-th>
                                <vs-th style="min-width: 200px">Cost</vs-th>
                            </template>
                            <template slot-scope="{ data }">
                                <vs-tr
                                    :data="tr"
                                    :key="indextr"
                                    v-for="(tr, indextr) in data"
                                >
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.min_qty"
                                        />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.max_qty"
                                        />
                                    </vs-td>
                                    <vs-td>
                                        <vs-input
                                            class="w-full"
                                            v-model="tr.cost"
                                        />
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>
    </div>
</template>

<script type="text/javascript">
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    name: "master-client-transaction-rate-create",
    components: {
        vSelect,
        flatPickr,
    },
    data() {
        return {
            calculation_types: ["per_piece", "per_month"],
            isLoading: false,
            formTypes: {
                inbound: "per_piece",
                outbound: "per_piece",
                storage: "per_piece",
            },
            client_id: null,
            storageItems: [
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
            ],
            inboundItems: [
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
            ],
            outboundItems: [
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
            ],
            client: {
                data: [],
                loading: false,
                endpoint: "master/clients",
                objectKey: "client_code",
            },
        };
    },
    watch: {
        isLoading: function () {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
    },
    methods: {
        save() {
            const data = [
                {
                    client_id: this.client_id,
                    type: "storage",
                    calculation_type: this.formTypes.storage,
                    details: this.storageItems,
                },
                {
                    client_id: this.client_id,
                    type: "inbound",
                    calculation_type: this.formTypes.inbound,
                    details: this.inboundItems,
                },
                {
                    client_id: this.client_id,
                    type: "outbound",
                    calculation_type: this.formTypes.outbound,
                    details: this.outboundItems,
                },
            ];

            this.isLoading = true;
            this.$http
                .post("/master/client_transaction_rate", data)
                .then((resp) => {
                    this.isLoading = false;
                    this.$vs.notify({
                        color: "success",
                        title: "Succes",
                        text: "Save Succesfully",
                    });
                    this.$router.push({ name: "dashboard" });
                })
                .catch((resp) => this.handleError(resp));
        },
        getRate() {
            this.resetForm();

            this.isLoading = true;
            this.$http
                .get(
                    `/master/client_transaction_rate?client_id=${this.client_id}`
                )
                .then((resp) => {
                    this.isLoading = false;

                    const types = {
                        storage: "storageItems",
                        inbound: "inboundItems",
                        outbound: "outboundItems",
                    };

                    resp.data.forEach((d) => {
                        this.formTypes[d.type] = d.calculation_type;
                        d.details.forEach((detail, index) => {
                            this[types[d.type]][index].min_qty = detail.min_qty;
                            this[types[d.type]][index].max_qty = detail.max_qty;
                            this[types[d.type]][index].cost = detail.cost;
                        });
                    });
                })
                .catch((resp) => this.handleError(resp));
        },
        resetForm() {
            this.formTypes = {
                inbound: "per_piece",
                outbound: "per_piece",
                storage: "per_piece",
            };

            this.storageItems = [
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
            ];
            this.inboundItems = [
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
            ];
            this.outboundItems = [
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
                {
                    min_qty: 0,
                    max_qty: 0,
                    cost: 0,
                },
            ];
        },
    },
    beforeMount() {
        if (this.isLoading) {
            this.$vs.loading();
        }
    },
};
</script>
